// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3vH-9","rootSuccess":"CompleteLink_rootSuccess__2M7nL","rootFailure":"CompleteLink_rootFailure__iIdZ_","isDisabled":"CompleteLink_isDisabled__1M9WS"};